import { Typography } from '@material-ui/core';
import { MAX_TRIAL_INSIGHTS_COUNT } from '../unlock/UnlockUtils';

export function DescriptionTooltipContent() {
  return (
    <Typography>
      Free access includes {MAX_TRIAL_INSIGHTS_COUNT} insights. Upgrade to
      Pricing Insights Pro in Shipper TMS for more.
    </Typography>
  );
}
